import styled, {keyframes} from 'styled-components';
import {textSizes} from '@stencil/build-theme';

export const TierBenefitsCardOuter = styled.div`
  position: absolute;
  width: 25rem;
  z-index: 10;
  border-radius: 0.8rem;
  visibility: ${props => (props.$isVisible ? 'visible' : 'hidden')};
  background: #fff;
  box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.25);
  top: 2.5rem;
  left: -7rem;
`;

export const TierBenefitsCard = styled.div`
  /* background: ${props =>
    `linear-gradient(180deg, ${props.$gradient || 'rgba(255, 255, 255, 0) 17.68%, #ffece5 91.94%'})`}; */
  background: linear-gradient(192.97deg, rgba(255, 255, 255, 0) 17.68%, #ffece5 91.94%);
  padding: 1.2rem;
  border-radius: 0.8rem;
`;

export const TierBenefitsHeader = styled.h5`
  ${textSizes.SmallW3};
  color: #222222;
`;

export const TierBenefitsList = styled.ul`
  margin-top: 0.8rem;
`;

export const TierBenefitsListItem = styled.li`
  gap: 0.6rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.4rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TierBenefitsListItemDesc = styled.p`
  ${textSizes.SmallW1};
  color: #222222;
`;

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: white;
    z-index: 9;
  }
`;

export const TipPositioning = styled(TipUI)`
  right: 60%;
  top: -1.2rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => props.bgColor};
    box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
      ${props => props.theme.colors.shadow.base};
  }
`;

export const IconImg = styled.img`
  min-width: 1.2rem;
  height: 1.2rem;
`;
